(function () {
    "use strict";

    angular.module("app").component("habilIvm", {
        templateUrl: "@/clearance/clearance-person.html",
        controller: ClearanceController,
        controllerAs: "vm",
        bindings: {
            clearance: "=",
        }
    });

    ClearanceController.$inject = ["$rootScope", "controllerDecorator", "habilDate", "enumService",];
    function ClearanceController($rootScope, controllerDecorator, habilDate, enumService) {
        const vm = Object.assign(this, {
            getStyle,
            getLinkedToDummyText,
            openPerson,
            openOrg,
            suspendClearance,
            cancelSuspendedClearance,
        });
        controllerDecorator.Decorate(vm, ["navigation", "dialog"]);

        vm.VMTypes = $rootScope.codeVMTypes;
        vm.VMLevels = $rootScope.codeIVMLevels;

        vm.ClearanceStatusCodes = enumService.ClearanceStatusCodes;

        function getStyle() {
            if (!vm.clearance)
                return "";

            if (vm.clearance.LinkedToDummyOn || vm.clearance.Status == enumService.ClearanceStatusCodes.Inactive)
                return "bg-info";

            if (!vm.clearance.StillValid)
                return "bg-danger";

            const today = habilDate.GetDateOnly(new Date());
            const warningDate = habilDate.AddMonths(today, 12);
            const expirationDate = habilDate.GetDateOnly(vm.clearance.DateValidTo);

            if (expirationDate.valueOf() < warningDate.valueOf())
                return "bg-warning";

            return "bg-success";
        }

        function openPerson() {
            if (vm.clearance.DossierPerson) {
                vm.Navigator.OpenDossierPerson(vm.clearance.DossierPerson.PublicId);
            }
        }

        function openOrg() {
            if (vm.clearance.DossierOrganisation && vm.clearance.DossierPerson) {
                vm.Navigator.OpenDossierOrganisation(vm.clearance.DossierOrganisation.PublicId);
            }
        }

        function getLinkedToDummyText() {
            // text format will be X years, X months, X days
            if (!vm.clearance?.LinkedToDummyOn)
                return;

            const daysDifferent = Math.ceil(Math.abs(new Date() - vm.clearance.LinkedToDummyOn) / (1000 * 60 * 60 * 24));
            const duration = moment.duration(daysDifferent, "days");
            const numberOfYears = duration._data.years;
            const numberOfMonths = duration._data.months;
            const numberOfDays = duration._data.days;

            return `${numberOfYears} ${$rootScope.translations.Years}, ${numberOfMonths} ${$rootScope.translations.Months}, ${numberOfDays} ${$rootScope.translations.Days} `;
        }

        function suspendClearance() {
            const options = {
                inputType: "textarea",
                rows: 5,
                required: true,
                size: "large",
                title: vm.getTranslation("TemporarySuspendClearance"),
            };

            vm.Dialog.Prompt(options)
                .then(onSubmit)
                .catch(angular.noop);

            function onSubmit(reason) {
                vm.SetLoadingState(true);

                const payLoad = {
                    PublicId: vm.clearance.PublicId,
                    Reason: reason,
                };

                vm.Api.SuspendPersonSecurityClearance(
                    payLoad,
                    response => {
                        const result = response.data;
                        if (!result.Success) {
                            vm.ShowError(vm.getTranslation(result.Errors[0]));
                        }
                        else {
                            vm.clearance.Status = result.Status;
                            vm.clearance.StatusDate = result.StatusDate;
                        }
                    },
                    vm.ShowError,
                    () => vm.SetLoadingState(false)
                );
            }
        }

        function cancelSuspendedClearance() {
            vm.SetLoadingState(true);

            const payLoad = {
                PublicId: vm.clearance.PublicId,
            };

            vm.Api.CancelSuspendedPersonSecurityClearance(
                payLoad,
                response => {
                    const result = response.data;
                    if (!result.Success) {
                        vm.ShowError(vm.getTranslation(result.Errors[0]));
                    }
                    else {
                        vm.clearance.Status = result.Status;
                        vm.clearance.StatusDate = result.StatusDate;
                    }
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }
    }
})();